import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const getFreemiumPlanDetails = async ({ planId, }) => {
    console.log(`Mid-hook Plan ID: ${planId}`);
    const plan = await api
        .get(`trainingPlans/${planId}`, {
        searchParams: { detailed: true },
    })
        .json();
    return plan;
};
export const getFreemiumPlanQueryOptions = (planId) => {
    return queryOptions({
        queryKey: ["freemium_plan", planId],
        queryFn: () => getFreemiumPlanDetails({ planId }),
    });
};
export const useFreemiumPlanDetails = ({ queryConfig, planId }) => {
    return useQuery({
        ...getFreemiumPlanQueryOptions(planId),
        ...queryConfig,
    });
};
//# sourceMappingURL=getFreemiumPlanDetails.js.map